export default {
    namespaced: true,
    state: {
        filter: {},
        cookieName: ''
    },
    getters: {
        getFilter: state => state.filter,
        getCookieName: state => state.cookieName,
        getCurrentCustomer: state => state.filter.customer,
        getCurrentProject: state => state.filter.project,
        getUnassigned: state => state.filter.unassigned
    },
    mutations: {
        SET_OWNER_COMPANY(state, owner_company) {
            state.filter.owner_company = owner_company;
        },
        SET_OPTION(state, option) {
            state.filter.option = option;
        },
        SET_CALENDAR_VIEW(state, activeView) {
            state.filter.activeView = activeView;
        },
        SET_HOUR_STATUS(state, status) {
            state.filter.status = status;
        },
        SET_CALENDAR_NAVIGATION(state, navigation) {
            state.filter.navigation = navigation;
        },
        SET_VAT(state, vats) {
            state.filter.tax_exists = vats.tax_exists;
            state.filter.tax_exempt = vats.tax_exempt;
            state.filter.btw_reversed_charge = vats.btw_reversed_charge;
        },
        setCurrentCustomer(state, currentCustomer) {
            state.filter.customer = currentCustomer;
        },
        SET_UNASSIGNED(state, value) {
            state.filter.unassigned = value;
        },
        SET_SUPPLIER(state, supplier) {
            state.filter.supplier = supplier;
        },
        SET_CUSTOMER_PROJECT(state, data) {
            state.filter.customer = data.customer;
            state.filter.project = data.project;
        },
        SET_INVOICE_CUSTOMER_PROJECT(state, data) {
            state.filter.recipient_customer = data.recipient_customer;
            state.filter.project = data.project;
        },
        SET_QUOTATION_CUSTOMER_PROJECT(state, data) {
            state.filter.recipient_customer = data.recipient_customer;
            state.filter.project = data.project;
        },
        SET_PAYMENT_TYPE(state, payment_type) {
            state.filter.payment_type = payment_type;
        },
        SET_CREATED_BY(state, created_by) {
            state.filter.created_by = created_by;
        },
        SET_BALANCE_SHEET_SORTING(state, balance_sheet_ordering) {
            state.filter.balance_sheet_ordering = balance_sheet_ordering;
        },
        SET_UPDATE_FILTER_BALANCE_SHEET(state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_TRANSACTION_TYPE(state, transaction_type) {
            state.filter.status = transaction_type;
        },
        SET_TRANSACTION_AMOUNT (state, amount_type) {
            state.filter.amount_type = amount_type
        },
        SET_COST_TYPE (state, cost_type) {
            state.filter.cost_type = cost_type
        },
        SET_COST_STATUS (state, cost_status) {
            state.filter.status = cost_status
        },
        SET_COST_VERIFIED (state, is_verified) {
            state.filter.is_verified = is_verified
        },
        SET_VERIFY_COST_SELECTION (state, verifySelectionChecked) {
            state.filter.verifySelectionChecked = verifySelectionChecked
        },
        SET_COST_SEARCH (state, search_term) {
            state.filter.search = search_term
        },
        SET_CONTACT_ACTIVE (state, is_archived) {
            state.filter.is_archived = is_archived
        },
        SET_HOURS_ACTIVE (state, is_archived) {
            state.filter.exclude_archived = null
            if (is_archived !== null)
                state.filter.exclude_archived = is_archived
        },
        SET_CONTACT_TYPE (state, contact_type) {
            state.filter.contact_type = contact_type
        },
        SET_HOURS_SORTING (state, ordering) {
            state.filter.hours_ordering = ordering;
        },
        SET_CONTACT_SORTING (state, ordering) {
            state.filter.ordering = ordering
        },
        SET_UPDATE_FILTER_HOURS (state) {
            state.filter = Object.assign({},state.filter)
        }, 
        SET_TRIP_TYPE (state, type) {
            state.filter.type = type
        },
        SET_TRANSPORT_TYPE (state, transport_type) {
            state.filter.transport_type = transport_type
        },
        SET_CAR (state, car) {
            state.filter.car = car;
        },
        SET_BANK_ACCOUNT (state, account) {
            state.filter.account = account
        },
        SET_DOCUMENT_TYPE (state, document_type) {
            state.filter.type = document_type;
        },
        SET_PRODUCT_FORMAT (state, product_format) {
            state.filter.product_format = product_format;
        },
        SET_PRODUCT_YEAR (state, product_year) {
            state.filter.product_year = product_year;
        },
        SET_UPDATE_FILTER_COSTS (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_UPDATE_FILTER_CONTACTS (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_UPDATE_FILTER_TRIPS (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_UPDATE_FILTER_BANK (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_UPDATE_FILTER_INVOICES (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_UPDATE_FILTER_DOCUMENTS (state) {
            state.filter = Object.assign({}, state.filter)
        },
        SET_UPDATE_FILTER_PRODUCTS (state) {
            state.filter = Object.assign({}, state.filter)
        },
        SET_UPDATE_FILTER_CUSTOMER_INSIGHT (state, value) {
            if ([0,1,2].includes(value)) state.filter.report_option = value
        },
        SET_UPDATE_FILTER_CASH_FLOW (state, value) {
            if (value) state.filter.cashflow_options = value
        },
        SET_UPDATE_FILTER_REVENUE_EXPENSES (state, value) {
            if (value) state.filter.revenue_expenses_options = value
        },
        SET_UPDATE_FILTER_SUPPLIER_INSIGHT (state) {
            state.filter = Object.assign({}, state.filter)
        },
        SET_UPDATE_FILTER_QUOTATIONS (state, value) {
            state.filter.status = value
            state.filter = Object.assign({}, state.filter)
        },
        SET_UPDATE_FILTER_HOURS_REPORT (state) {
            if (state.filter.start_date == null || state.filter.end_date == null) {
                var curr = new Date; // get current date
                var first = curr.getDate() - curr.getDay() + 1; // First day is the day of the month - the day of the week
                var last = first + 6; // last day is the first day + 6
                
                state.filter.start_date = new Date(curr.setDate(first)).format("Y-m-d");
                state.filter.end_date = new Date(curr.setDate(last)).format("Y-m-d");
                state.filter.option = 'any';
            }
            state.filter = Object.assign({}, state.filter);
        },
        SET_START_END_DATE (state, dates) {
            state.filter.start_date = dates.start_date;
            state.filter.end_date = dates.end_date
        },
        SET_IMPORT_CUSTOMER (state, payload) {
            switch (payload.type) {
                case 'customer':
                    state.filter.customer = payload.customer_id
                    delete state.filter.no_customer
                    delete state.filter.customer_or_null
                    break;
                case 'no_customer':
                    state.filter.no_customer = true
                    delete state.filter.customer
                    delete state.filter.customer_or_null
                    break;
                case 'customer_or_null':
                    state.filter.customer_or_null = payload.customer_id
                    delete state.filter.no_customer
                    delete state.filter.customer
                    break;
            }
        },
        SET_UPDATE_FILTER_FILES(state) {
            state.filter = Object.assign({}, state.filter)
        },
        SET_UPDATE_FILTER_FILES_TYPE(state, payload) {
            state.filter.type = payload
        },
        SET_UPDATE_FILTER_FILES_SUBTYPE(state, payload) {
            state.filter.subtype = payload
        },
        SET_IMPORT_HOURS_PROJECT(state, project_id) {
            state.filter.project = project_id
        },
        SET_ACCOUNTANT_CONNECTION_STATUS_FILTER(state, status) {
            state.filter.status = status;
        },
        SET_UPDATE_FILTER_ACCOUNTANTS(state) {
            state.filter = Object.assign({}, state.filter);
        },
        SET_UPDATE_FILTER_COST_CATEGORIES(state, value) {
            if (value) state.filter.cost_categories_year = value
        },
        SET_COOKIES (state) {
            state.filter = Object.assign({},state.filter)
        },
        SET_COOKIE_NAME (state, cookieName) {
            state.cookieName = cookieName
        },
        LOAD_COOKIE (state) {
            state.filter = this.getters.getRoot.$cookies.get(state.cookieName) || {};
        },
        /**
       * SET_FILTER
       * @param {*} state 
       * @param {*} payload {filter_name, filter_value}
       */
        SET_FILTER (state, payload) {
            payload.filters.forEach(filter_item => {
                state.filter[filter_item.name] = filter_item.value
            });
        },
        SET_REFRESH_FILTERED (state) {
            state.filter = Object.assign({}, state.filter)
        },
    },
    actions: {
        setCookienameAndReadCookie ({commit}, cookieName) {
            commit('SET_COOKIE_NAME', cookieName)
            commit('LOAD_COOKIE', cookieName)
        },
        updateFilter ({ commit }, payload) {
            commit('SET_FILTER', payload)
            if (payload.refresh) {
                commit('SET_REFRESH_FILTERED')
            }
        }
    }
};
